import React from 'react';
import { Link } from 'react-router-dom';
import ProfileAdvertisementsItem from "../items/profile_advertisements_item";
import NoUserAd from "../items/no_user_ad";
import Loading from "../../../common/components/Loading";
import { AdFilterTabButtons } from "../ad/AdFilterTabButtons";
import { AdControlContent } from "../ad/AdControlContent";
import { t } from 'i18next';

export function AdvertisementsUI(
    handleBackClick,
    filter,
    setFilter,
    counts,
    searchText,
    handleSearchChange,
    categories,
    sort,
    handleSortChange,
    loading,
    filteredAdsData,
    getNoUserAdText
) {
    return (
        <div className="w-full">
            {/* Header */}
            <div className="flex items-center justify-between mb-5">
                <button
                    onClick={handleBackClick}
                    className="md:hidden flex items-center gap-2 text-gray-500 text-sm"
                >
                    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                    </svg>
                </button>
                <Link to="/adform" className="ml-auto">
                    <button className="flex items-center gap-2 bg-[#147F26] hover:bg-[#0f5f1a] text-white text-sm font-semibold px-4 py-2.5 rounded-xl transition-colors">
                        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                        </svg>
                        {t('createAnnouncement')}
                    </button>
                </Link>
            </div>

            {/* Filter tabs */}
            {AdFilterTabButtons(filter, setFilter, counts)}

            {/* Search + Sort */}
            {AdControlContent(searchText, handleSearchChange, categories, sort, handleSortChange)}

            {/* List */}
            <div className="flex flex-col gap-3">
                {loading ? (
                    <div className="py-10 flex justify-center"><Loading /></div>
                ) : filteredAdsData.length > 0 ? (
                    filteredAdsData.map(ad => (
                        <ProfileAdvertisementsItem key={ad.id} item={ad} />
                    ))
                ) : (
                    <NoUserAd {...getNoUserAdText()} />
                )}
            </div>
        </div>
    );
}
